/*******************************************************
  INVENI STYLE SWITCHER (Themes + Display Modes)
  - Supports 4 Themes
  - Supports 10 Display Modes
  - Saves preferences to localStorage
  - Applies data-theme + data-mode to <html>
********************************************************/

(function () {
  const html = document.documentElement;

  /* -------------------------------
     1) Available Themes
  -------------------------------- */
  const THEMES = ["default", "royal", "forest", "purple"];

  /* -------------------------------
     2) Available Display Modes
  -------------------------------- */
  const MODES = [
    "light",
    "dark",
    "sepia",
    "paper",
    "dyslexia",
    "amoled",
    "high-contrast",
    "warm",
    "cool",
    "quiet",
  ];

  /* -------------------------------
     3) Load saved options
  -------------------------------- */
  const savedTheme = localStorage.getItem("inveni-theme");
  const savedMode  = localStorage.getItem("inveni-mode");

  /* Apply saved theme */
  if (savedTheme && THEMES.includes(savedTheme)) {
    html.setAttribute("data-theme", savedTheme);
  }

  /* Apply saved mode */
  if (savedMode && MODES.includes(savedMode)) {
    html.setAttribute("data-mode", savedMode);
  }

  /* -------------------------------
     4) Watch for click events
  -------------------------------- */

  document.addEventListener("click", function (e) {
    const el = e.target.closest("[data-theme-select]");
    const el2 = e.target.closest("[data-mode-select]");

    /* Theme selection */
    if (el) {
      const theme = el.getAttribute("data-theme-select");
      html.setAttribute("data-theme", theme);
      localStorage.setItem("inveni-theme", theme);
      return;
    }

    /* Mode selection */
    if (el2) {
      const mode = el2.getAttribute("data-mode-select");
      html.setAttribute("data-mode", mode);
      localStorage.setItem("inveni-mode", mode);
      return;
    }
  });

})();
